export * from './config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/~/ngx-webstorage/dist/interfaces/index.js
// module id = ../../../../ngx-webstorage/dist/interfaces/index.js
// module chunks = 3